import { use } from "react";
import { WizardContext } from "./Wizard";

/**
 * Controls for multi-step wizard.
 * @example
 * Step1 --> Step2 [VariantA, VariantB] --> Step3 --> Step4
 */
export function useWizard() {
  return use(WizardContext);
}
